import { render } from "./DateRangePicker.vue?vue&type=template&id=6d0de474&scoped=true"
import script from "./DateRangePicker.vue?vue&type=script&lang=js"
export * from "./DateRangePicker.vue?vue&type=script&lang=js"

import "./DateRangePicker.vue?vue&type=style&index=0&id=6d0de474&lang=scss"
import "./DateRangePicker.vue?vue&type=style&index=1&id=6d0de474&lang=scss&scoped=true"

import exportComponent from "/Users/davidolmos/Desktop/vue3-daterange-picker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0de474"]])

export default __exports__